import Desktop1 from '../../../Attachments/Images/Desktop1.png';
import Desktop2 from '../../../Attachments/Images/Desktop2.png';
import Desktop3 from '../../../Attachments/Images/Desktop3.png';
import Mobile1 from '../../../Attachments/Images/Mobile1.png';
import Mobile2 from '../../../Attachments/Images/Mobile2.png';


const Carousel2Data = [
    {
        title: "UI Soup",
        Links: "",
        desktopImage: Desktop1,
        mobileImage: Mobile1,
    },
    {
        title: "Goldcrown Labs",
        Links: "",
        desktopImage: Desktop2,
        mobileImage: Mobile2,
    },
    {
        title: "Close Concierge",
        Links: "",
        desktopImage: Desktop3,
        mobileImage: Mobile2,
    },

]

export default Carousel2Data;